import { ErrorAlert } from "components/ErrorAlert/ErrorAlert";
import { array, InferType, number, object, string } from "yup";

export const SchoolProfileSummaryFormSchema = object({
  websiteUrl: string().url(),
  summary: string(),
});

export const SchoolArrivingOnsiteFormSchema = object({
  dayOfContact: string(),
  dayOfEmail: string().email(),
  dayOfPhone: string(),
  parkingCost: string(),
  parkingLocation: string(),
  checkinLocation: string(),
  checkinProcedure: string(),
  checkoutLocation: string(),
  checkoutProcedure: string(),
});

export const SchoolSitePoliciesFormSchema = object({
  subPolicies: object({
    leavingClassroom: string(),
    lunchProtocol: string(),
    dressCode: string(),
    electronics: string(),
    emergencyProtocol: string(),
    lockdownProtocol: string(),
    escalation: string(),
    takingAttendance: string(),
    codeWords: string(),
  }).optional(),
  studentPolicies: object({
    leavingClassroom: string(),
    lunchProtocol: string(),
    dressCode: string(),
    electronics: string(),
  }).optional(),
});

export const SchoolScheduleFormSchema = object({
  hours: array().of(
    object({
      start: number(),
      end: number(),
      day: string().matches(/(mon|tue|wed|thu|fri)/),
    }),
  ),
});

type ErrorListProps = {
  errorList: string[];
};

export type CombinedSchoolUpdateSchema = InferType<typeof SchoolProfileSummaryFormSchema> &
  InferType<typeof SchoolArrivingOnsiteFormSchema> &
  InferType<typeof SchoolScheduleFormSchema> &
  InferType<typeof SchoolSitePoliciesFormSchema>;

export const ErrorList: React.FC<ErrorListProps> = ({ errorList }) => {
  return (
    <div>
      {errorList.map((item, idx) => {
        return <ErrorAlert key={idx}>{item}</ErrorAlert>;
      })}
    </div>
  );
};
